/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsGauge: {
  name: 'gauge';
  data: string;
} = {
  name: 'gauge',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.062 15H7.1a5.006 5.006 0 0 1 3.9-3.9V8.062A8.004 8.004 0 0 0 4.062 15ZM12 6c-5.148 0-9.387 3.89-9.94 8.892C1.928 16.107 2.93 17 4 17h4a1 1 0 0 0 1-1 3 3 0 1 1 6 0 1 1 0 0 0 1 1h4c1.072 0 2.073-.893 1.94-2.108C21.386 9.89 17.148 6 12 6Zm1 2.062V11.1a5.006 5.006 0 0 1 3.9 3.9h3.038A8.004 8.004 0 0 0 13 8.062Z" fill="currentColor"/></svg>`,
};
